/* ─── Helpers ──────────────────────────── */
export const $ = s => document.querySelector(s);
export const $$ = s => document.querySelectorAll(s);

// rAF-based interval — never queues up when tab is backgrounded.
// Returns an object with .stop() for cancellation via clearThrottled().
export function throttledInterval(fn, ms) {
	let acc = 0, last = performance.now(), stopped = false;
	function tick(now) {
		if (stopped) return;
		const dt = Math.min(now - last, ms * 2); // cap elapsed to prevent burst
		last = now;
		acc += dt;
		if (acc >= ms) {
			acc -= ms;
			fn();
		}
		requestAnimationFrame(tick);
	}
	requestAnimationFrame(tick);
	return { stop() { stopped = true; } };
}

export function clearThrottled(handle) {
	if (handle && handle.stop) handle.stop();
}
